<template>
  <div id="nav">
    <b-navbar toggleable="lg" type="dark">
      <b-navbar-brand href="#"
        ><img alt="Mealtrips logo" src="../assets/logo.png" class="logo"
      /></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse">
        <template #default="{ expanded }">
          <Icons v-if="expanded" name="close" class="close" />
          <Icons v-else name="bar" />
        </template>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="#hero">Home</b-nav-item>
          <b-nav-item href="#about">About</b-nav-item>
          <b-nav-item href="#how">How it Works</b-nav-item>
          <b-nav-item href="#faq">FAQ</b-nav-item>
          <b-nav-item href="#contact">Contact</b-nav-item>
          <b-nav-item href="https://mealtrips.wordpress.com" target="_blank"
            >Blog</b-nav-item
          >
          <b-nav-item href="https://play.google.com/store/apps/details?id=com.ccr.mealtrips" target="_blank"><b-button class="get">Get the App</b-button></b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import Icons from "./Icons.vue";

export default {
  name: "Nav",
  components: {
    Icons,
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Proza+Libre:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&display=swap");

#nav {
  font-family: "Proza Libre", sans-serif;
  position: fixed;
  z-index: 999;
  width: 100%;
}
.navbar {
  background: #fefefe;
  color: #13232a;
  padding: 24px 8%;

  .navbar-brand {
    width: 140px;
    .logo {
      width: 100%;
      height: 48px;
    }
  }

  .navbar-nav {
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 18px;
    .nav-link {
      color: #13232a;
    }
    .nav-link:hover {
      color: #165049;
    }
    .get {
      background: #e56e10;
      padding: 16px 32px;
      border-radius: 24px;
      color: #fefefe;
      border: none;
    }
    .navbar-dark .navbar-toggler {
      border: none;
    }
    button:focus {
      outline: none;
      outline-color: none;
      outline-style: none;
      outline-width: none;
    }
  }
}

@media (max-width:768px) {
  .navbar{
    padding: 14px 8%;
    .navbar-brand {
    width: 70px;
    .logo {
      width: 100%;
      height: 30px;
    }
  }
  }
  .get{
    margin-left: 0;
  }
}
</style>